export class HotelDetails {
  static empty() {
    return new HotelDetails()
  }

  constructor() {
    this.loading = true
    this.coBrandImage = {}

    this.hotel = {
      address: {},
      image: {}
    }
  }
}

export class BookingSummary {
  static empty() {
    return new BookingSummary()
  }

  constructor() {
    this.loading = true
    this.customer = {}
    this.priceSummary = {
      totalWithTax: {},
      totalTaxAndFees: {}
    }

    this.stay = {
      rate: {
        conditions: {
          features: [],
          instructions: [],
          guaranteePolicies: [],
          cancellationPoliciesExtended: {
            policies: []
          }
        }
      },
      occupancy: {},
      externalBooking: false
    }

    this.guaranteeType = {}
    this.rooms = []
  }
}

export class DynamicLinkList {
  static empty() {
    return new DynamicLinkList()
  }

  constructor() {
    this.loading = true

    this.title = undefined
    this.subtitle = undefined
    this.url = undefined

    this.ctaText = undefined
    this.img = undefined
  }
}
